import getOr from 'lodash/fp/getOr'
import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { bindPromiseCreators } from '../../../../../utils/routines'
import { createRequestInfoPromise } from '../../../routines'
import { withRequestInfoSaga } from '../../../saga'

import { compileDocUploadPath, getRequireModel200Default, legalFormQuestPeriodTax, isCanarian } from '../utils'

const mapDispatchToProps = dispatch => ({
  ...bindPromiseCreators({
    createRequestInfo: createRequestInfoPromise
  }, dispatch),
  ...bindActionCreators({
    redirect: push
  }, dispatch)
})
export const connector = connect(null, mapDispatchToProps)

// formik
const mapPropsToValues = ({ application }) => ({
  must_declare_auditory: getOr(false, 'document_info.must_declare_auditory')(application),
  require_model200: getOr(getRequireModel200Default(application), 'document_info.require_model200')(application),
  igic: getOr(
    isCanarian(application.data.zip_code) ? '' : null,
    'document_info.igic'
  )(application),
  period_tax: getOr(
    legalFormQuestPeriodTax.includes(application.data.legal_form) ? '' : null,
    'document_info.period_tax'
  )(application)
})

const validationSchema = ({ application }) => yup.object().shape({
  must_declare_auditory: yup.boolean(),
  require_model200: yup.boolean(),
  igic: isCanarian(application.data.zip_code)
    ? yup.string().oneOf(['igic', 'iva', 'both']).required()
    : yup.string().nullable(),
  period_tax: legalFormQuestPeriodTax.includes(application.data.legal_form)
    ? yup.string().oneOf(['trimestral', 'mensual']).required()
    : yup.string().nullable()
})

async function handleSubmit(values, { props, setSubmitting, setStatus }) {
  try {
    const id = props.application.id
    await props.createRequestInfo({
      id,
      ...values
    })
    return props.redirect(compileDocUploadPath({ id }))
  } catch (error) {
    setStatus({ error })
  } finally {
    setSubmitting(false)
  }
}
const formik = withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit
})

export default compose(
  withRequestInfoSaga,
  connector,
  formik
)
